import isNil from 'lodash/isNil'
import { Map } from 'immutable'

function isValidId (id) {
  if (isNil(id)) {
    return false
  }

  const isValidNumber = !Number.isNaN(Number(id))
  return isValidNumber
}

function isNonEmptyString (str) {
  return typeof str === 'string' && str.length > 0
}

export function isSeriesVideo (video) {
  const data = video.get('data', Map())

  const seriesTitle = data.get('seriesTitle')
  if (isNonEmptyString(seriesTitle)) {
    return true
  }

  const seriesId = data.get('seriesId')
  if (isValidId(seriesId)) {
    return true
  }

  const seriesEpisode = data.get('episode')
  if (isValidId(seriesEpisode)) {
    return true
  }

  return false
}

export default isSeriesVideo
